<template>
  <div class="ui-footer">
    <div class="ui-footer-links">
      <div class="ui-footer-links__item termsCondtionPoint" @click="openModal">
        Terms of Service
      </div>
      <div class="ui-footer-links__item">
        <b>Privacy Policy</b>
      </div>
      <div class="ui-footer-links__item">Personal information Consignment</div>
      <div class="ui-footer-links__item">&#169; Samsung</div>
    </div>
    <ur-modal
      ref="modal"
      title="Terms &amp; Condition"
      class="termsCondition"
      xlarge
    >
      <template>
        <div class="messageBoxContent">
          <h2 class="messageBoxTitle" style="margin-bottom: 10px">
            End User License Agreement
          </h2>
          <h2>GENERAL DISCLAIMER-</h2>

          <p>
            This document is an electronic record in terms of Information
            Technology Act, 2000 and Rules there under as applicable and the
            amended provisions pertaining to electronic records in various
            statutes as amended by the Information Technology Act, 2000. This
            electronic record is generated by a computer system and does not
            require any physical or digital signatures.
          </p>
          <p>
            This document is published in accordance with the provisions of Rule
            3 (1) of the Information Technology (Intermediaries guidelines)
            Rules, 2011 that require publishing the rules and regulations,
            privacy policy and Terms of Use for access or usage of DMS System
            (“System”).
          </p>
          <p>
            Your use of the System is governed by the following terms and
            conditions ("Terms of Use") including the applicable policies which
            are incorporated herein by way of reference. If you transact on/ use
            System, You shall be subject to the policies that are applicable to
            the System for such transaction. By mere use of System, You shall be
            contracting with Samsung India Electronics Pvt. Ltd. and these terms
            and conditions including the policies constitute your binding
            obligations, with Samsung.
          </p>
          <p>
            <b
              >ACCESSING, BROWSING OR OTHERWISE USING THE SITE/SYSTEM INDICATES
              YOUR AGREEMENT TO ALL THE TERMS AND CONDITIONS UNDER THESE TERMS
              OF USE, SO PLEASE READ THE TERMS OF USE CAREFULLY BEFORE
              PROCEEDING.</b
            >
          </p>
          <p>
            By impliedly or expressly accepting these Terms of Use or by access
            /use of the System, You also accept and agree to be bound by Samsung
            Policies (including but not limited to Privacy Policy available on
            3rd March, 2016 as amended from time to time.
          </p>
          <p>
            For the purpose of these Terms of Use, wherever the context so
            requires "You/ you" “your” or "User" shall mean any natural or legal
            person who has agreed to become a user on the System by providing
            registration data while registering on the System as registered user
            using the computer systems. The term “Samsung”, "we", "us", "our"
            shall mean Samsung India Electronics Pvt. Ltd
          </p>
          <p>
            DMS is an online system monitored and controlled by Samsung. This
            System is provided by Samsung for its own benefit and You and while
            we endeavor to keep the information up to date and correct, we make
            no representations or warranties of any kind, express or implied,
            about the completeness, accuracy, reliability, suitability or
            availability with respect to the System or the information,
            products, services, or related graphics contained on it for any
            purpose. Any reliance you place on such information is therefore
            strictly at your own risks and consequences. The information
            contained herein is provided on “As Is and As available basis” basis
            your inputs only and User is advised to cross check before placing
            reliance on the same.
          </p>
          <p>
            This System offers services that helps You to capture inter alia,
            purchase, sales, inventory and collection at each level in the
            channel network.
          </p>
          <p>
            Samsung takes no responsibility for, and will not be liable for, the
            System being temporarily unavailable due to technical issues beyond
            our control or being out of order or for any maintenance or updating
            thereof. Your business data and information, protection and
            maintenance thereof, is entirely your responsibility and shall
            continue to remain independent of your use, updating and access to
            this System.
          </p>
          <p>
            Your access to and use of the System is conditioned on your
            acceptance of, adherence to and compliance with these Terms. By
            accessing or using the System you agree to be bound by these Terms.
            If you disagree with any part of the terms, it is advised that you
            should not use or access the System.
          </p>
          <p><b>You Agree and Confirm</b></p>
          <ol>
            <li>
              That You shall use the System provided by us, for lawful purposes
              only and shall comply with all applicable laws and regulations
              while using the System. All the inputs and information provided
              shall be true, correct and accurate.
            </li>
            <li>
              You shall provide authentic and true information in all instances
              where such information is requested of You or your business. We
              reserve the right to confirm and validate the information and
              other details provided by You at any point of time. If upon
              confirmation Your details are found to be false (wholly or
              partly), We have the right and the sole discretion to reject and
              debar You from using the System and / or other affiliated systems
              without prior intimation whatsoever.
            </li>
          </ol>

          <p>
            You agree and confirm that You shall not use our System for any of
            the following purposes:
          </p>
          <ol>
            <li>
              Disseminating any unlawful, harassing, libelous, abusive,
              threatening, harmful, vulgar, obscene, or otherwise objectionable
              material.
            </li>
            <li>
              Transmitting material that encourages conduct that constitutes a
              criminal offence, results in civil liability or otherwise breaches
              any relevant laws, regulations or code of practice.
            </li>
            <li>Gaining unauthorized access to other computer systems.</li>
            <li>Breaching any applicable laws, rules or regulations.</li>
            <li>
              Making, transmitting or storing electronic copies of materials
              protected by copyright without the permission of the copyright
              owner.
            </li>
            <li>
              Do not access the System using a method other than the interface
              and the instructions that we provide.
            </li>
            <li>I Agree to the GST changes as per GST council notifications</li>
          </ol>
          <p>
            Using Our System does not give You ownership of any intellectual
            property rights in System or the content You access. These terms do
            not grant you the right to use any branding or logos used in the
            System. Don’t remove, obscure, or alter any legal notices displayed
            in or along with the System.
          </p>
          <p>
            In connection with your use of the System, we may send you
            announcements, administrative messages, and other information.
          </p>
          <p><b>Registration Obligations-</b></p>
          <p>
            In consideration of your use of the System, you represent that you
            have a legal capacity to form a binding contract and are not a
            person barred from using the System under the laws as applicable in
            India. You also agree to provide true, accurate, current and
            complete information about yourself and your business wherever
            prompted. If you provide any information that is untrue, inaccurate,
            not current or incomplete (or becomes untrue, inaccurate, not
            current or incomplete), or we have reasonable grounds to suspect
            that such information is untrue, inaccurate, not current or
            incomplete, we have the right to suspend or terminate your account
            and refuse any and all current or future use of our Website (or any
            portion thereof). You undertake to indemnify and keep indemnified
            Samsung and its affiliates for any loss, claim, damage, costs
            (including legal and professional costs) relating to any abuse or
            violation including those aforesaid.
          </p>
          <p>
            We will protect Your Information in accordance with our Privacy
            Policy. You agree to notify us immediately of any unauthorized use
            of your account or any other breach of security. We reserve the
            right to refuse service, or remove or edit content in our sole
            discretion.
          </p>
          <p>
            "Your Information" is defined as any information you provide to us
            during registration or while transacting on/ using the System. We
            will protect Your Information in accordance with our Privacy Policy.
            If you use the System, you are responsible for maintaining the
            confidentiality of your Login ID and Password and for restricting
            access to your computer, and you agree to accept responsibility for
            all activities that occur under Your Login ID or Password. We shall
            not be liable to any person for any loss or damage which may arise
            as a result of any failure by you to protect your password or
            account. You undertake to indemnify and keep indemnified Samsung for
            any loss, claim, damage, costs (including legal and professional
            costs) relating to your responsibility or liability or failure
            including those aforesaid. You agree to notify us immediately of any
            unauthorized use of your account or any other breach of security. We
            reserve the right to refuse service, terminate accounts, or remove
            or edit content in our sole discretion.
          </p>
          <p>
            This System is available to you only in India as of now. You agree
            not to use or attempt to use the System from outside India. Samsung
            may use technologies to verify your compliance. However, Samsung
            will regularly update you regarding the change in permissible
            geography.
          </p>
          <p><b>Electronic Communications-</b></p>
          <p>
            When you use the System or send email(s) to us, you are
            communicating with us electronically. You consent to receive
            communications from us electronically. We will communicate with you
            by email or SMS. You agree that all agreements, notices, disclosures
            and other communications that we provide to you electronically
            satisfy all legal requirements.
          </p>
          <p><b>SMS Communication-</b></p>
          <p>
            On registering on the System, you agree that we may use your
            registered mobile number as shared by you to send transaction
            related SMS to you. You also grant us permission that we may send
            you any transaction related SMS irrespective of having DND services
            activated on your mobile.
          </p>
          <p><b>Our Warranties and Disclaimers-</b></p>
          <p>
            We have taken every care in the preparation of the content of this
            System. We disclaim any warranties, express or implied, as to the
            accuracy of the information contained in any of the materials of
            this System. We shall not be liable to any person for any loss or
            damage which may arise from the use of any of the information
            contained in any of the materials of this System. We don’t make any
            commitments about the content within the System, the specific
            functions of the System, or their reliability, availability, or
            ability to meet your needs. We provide the System on “as is” basis
            only.
          </p>
          <p><b>Indemnification-</b></p>
          <p>
            You agree to defend, indemnify and hold us and our employees,
            directors, officers, agents and their successors and assigns,
            harmless from and against any and all claims, liabilities, damages,
            losses, costs and expenses, including attorney's fees, caused by or
            arising out of or relating to claims based upon your actions or
            inactions in relation to the use of the System, which may result in
            any loss or liability to us or any third party, including but not
            limited to breach of any warranties, representations or undertakings
            or in relation to the non-fulfillment of any of your obligations
            under these Terms or arising out of the your violation of any
            applicable laws, regulations including but not limited to
            intellectual property rights, payment of statutory dues and taxes,
            claim of libel, defamation, violation of rights of privacy or
            publicity, and infringement of intellectual property or other
            rights. This clause shall survive the expiry or termination of these
            Terms.
          </p>
          <p><b>Copyright Information-</b></p>
          <p>
            All rights, including copyright, in this System and any other
            intellectual property rights in our Products are owned by or
            licensed to us. None of the contents may be copied, reproduced,
            distributed, republished, downloaded, displayed, posted
            electronically or mechanically, transmitted, recorded, in any
            manner, photocopied or reproduced without prior written consent of
            Samsung. Any unauthorized or other use of the System, ,
            modification, distribution or republication without prior written
            consent of Samsung is strictly prohibited and may violate copyright
            or trademark laws.
          </p>
          <p><b>Privacy and System availability-</b></p>
          <p>
            Your information, as provided to us shall be protected as per our
            Privacy Policy.
          </p>
          <p>
            You will need Internet connectivity while using features of this
            System. User will be responsible to incur data charges for them as
            per his data plan. The performance of the System may be affected by
            factors like available memory and Internet Connectivity.
          </p>
          <p><b>Modification of Terms &amp; Conditions of System-</b></p>
          <p>
            We may at any time modify the Terms of Use of the System without any
            prior notification to you. You can access the latest version of the
            Terms at any given time on our System. You agree to regularly review
            the Terms on our System. However, if you continue to use the System
            you shall be deemed to have agreed to accept and abide by the
            modified Terms of this System.
          </p>
          <p><b>Governing Law and Jurisdiction-</b></p>
          <p>
            These Terms shall be construed in accord with the applicable laws of
            India. The Courts at New Delhi shall have exclusive jurisdiction in
            any proceedings arising out of these Terms.
          </p>
          <p><b>Limitation of Liability and Disclaimers-</b></p>
          <p>
            The System is provided without any warranties or guarantees and in
            an “AS IS” condition. You must bear the risks associated with the
            use of the System.
          </p>
          <p>
            We will not be responsible for any errors or omissions or for the
            results obtained from the use of such information or for any
            technical problems you may experience with the System. This
            disclaimer constitutes an essential part of these Terms. To the
            fullest extent permitted under applicable law, we or our partners
            shall not be liable for any indirect, incidental, special,
            consequential or exemplary damages, including but not limited to,
            damages for loss of profits, goodwill, use, data or other intangible
            losses arising out of or in connection with the System, or these
            Terms. We, our associates and technology partners make no
            representations or warranties about the accuracy, reliability,
            completeness, relevance and/or timeliness of any content,
            information, software, text, graphics, links or communications
            provided on or through the use of the System or that the operation
            of the System will be error free and/or uninterrupted and/or free of
            harmful components or that any of the Products or contents of the
            System, including your content or the third party content, will be
            secure or not otherwise lost or damaged.
          </p>
          <p>
            Except to the extent prohibited by law, we and our affiliates and
            licensors disclaim all warranties, including any implied warranties
            of merchantability, satisfactory quality, fitness for a particular
            purpose, non-infringement, or quiet enjoyment, and any warranties
            arising out of any course of usage of the System. Consequently,
            Samsung assumes no liability whatsoever for any monetary or other
            damage suffered by you on account of the delay, failure,
            interruption, or corruption of any data or other information
            transmitted in connection with use of the System; and/or any
            interruption or errors in the operation of the System.
          </p>
          <p><b>Security-</b></p>
          <p>
            You are prohibited from violating or attempting to violate the
            security of the System, including, without limitation, (a) accessing
            data not intended for you or logging onto a server or an account
            which you are not authorized to access; (b) attempting to probe,
            scan or test the vulnerability of a System or network or to breach
            security or authentication measures; (c) attempting to interfere
            with the System to any other user, host or network, including,
            without limitation, via means of submitting a virus, bug or worm or
            other file or software to the Site, overloading, "flooding,"
            "spamming," "mail bombing" or "crashing”; (d) sending unsolicited
            email, including promotions and/or advertising of products; or (e)
            forging any TCP/IP packet header or any part of the header
            information in any email or newsgroup posting. Violations of system
            or network security may result in civil or criminal liability.
            Samsung will investigate occurrences that may involve such
            violations and may involve, and cooperate with, law enforcement
            authorities in prosecuting users who are involved in such
            violations. You agree not to use any device, software or routine to
            interfere or attempt to interfere with the proper working of this
            System or any activity being conducted on this System. You agree,
            further, not to use or attempt to use any engine, software, tool,
            agent or other device or mechanism (including without limitation
            browsers, spiders, robots, avatars or intelligent agents) to
            navigate or search this System.
          </p>
          <p><b>Termination and Survival of the Terms-</b></p>
          <p>
            Samsung has the right to terminate, suspend or withdraw the System,
            or change the Terms anytime by giving a seven (7) days notice.
            Without limiting the foregoing, Samsung shall have the right to
            immediately terminate at any time your password or account or block
            your IP address, in the event of any conduct by you, which Samsung,
            in its sole discretion, considers to be unacceptable, or in breach
            of these Terms.
          </p>
          <p>
            You may terminate these Terms at any time, provided that you
            discontinue any further use of the System.
          </p>
          <p>
            Notwithstanding any other provisions of these Terms, or any general
            legal principles to the contrary, any provision of these Terms that
            imposes or contemplates continuing obligations on a party including
            our right to any Comments will survive the expiration or termination
            of these Terms.
          </p>
          <p><b>Entire Terms-</b></p>
          <p>
            If any part of these Terms is determined to be invalid or
            unenforceable pursuant to applicable law including, but not limited
            to, the warranty disclaimers and liability limitations set forth
            above, then the invalid or unenforceable provision will be deemed to
            be superseded by a valid, enforceable provision that most closely
            matches the intent of the original provision and the remainder of
            the Terms shall continue in effect. Unless otherwise specified
            herein, these Terms and the System policies constitute the entire
            agreement between you and Samsung with respect to our System and it
            supersedes all prior or contemporaneous communications and
            proposals, whether electronic, oral or written, between you and us
            with respect to the System. In addition to these Terms, you will
            also be required to be bound by any additional terms and conditions
            that may be made applicable to you by Samsung. Our failure to act
            with respect to a breach by you or others does not waive our right
            to act with respect to subsequent or similar breaches.
          </p>
          <h2>PRIVACY POLICY-</h2>
          <p>
            We value the trust you place in us. That's why we insist upon the
            highest standards for secure transactions and customer information
            privacy. Please read the following statement to learn about our
            information gathering and dissemination practices.
          </p>
          <p><b>Password Policy-</b></p>
          <p>Password must meet below complexity requirements:</p>
          <ol>
            <li>
              At least one Capital character (A - Z), one Lower character (a -
              z) &amp; one Number (0 - 9).
            </li>
            <li>At least one Special Character (for example, !, $, #, %).</li>
            <li>Password should not be same as last 2 passwords.</li>
            <li>Password should be at least six characters in length.</li>
            <li>
              Password should not contain the user's account name or parts of
              the user's full name that exceed two consecutive characters.
            </li>
          </ol>
          <p><b>Note-</b></p>
          <p>
            Our privacy policy is subject to change at any time without notice.
            To make sure you are aware of any changes, please review this policy
            periodically.
          </p>
          <p>
            By using DMS you agree to be bound by the terms and conditions of
            this Privacy Policy. If you do not agree please do not use or access
            DMS.
          </p>
          <p>
            By mere use of DMS, you expressly consent to our use and disclosure
            of your personal information in accordance with this Privacy Policy.
            This Privacy Policy is incorporated into and subject to the Terms of
            Use.
          </p>
          <p>
            <b
              >1. Collection of Personally Identifiable Information and other
              Information-</b
            >
          </p>
          <p>
            When you use DMS, we collect and store Your information which is
            provided by you from time to time. Our primary goal in doing so is
            to provide you a safe, efficient, smooth and customized experience.
            This allows us to provide services and features that most likely
            meet your needs, and to make your experience safer and easier. More
            importantly, while doing so we collect personal information from you
            that we consider necessary for achieving this purpose.
          </p>
          <p>
            If you choose to post messages on our message boards or leave
            feedback, we will collect that information you provide to us. We
            retain this information as necessary to resolve disputes, provide
            customer support and troubleshoot problems as permitted by law.
          </p>
          <p>
            We also collect your purchase, sales, inventory and collection
            details done by you at each level. We use these details for internal
            business purpose for various analysis and reporting purpose.
          </p>
          <p>
            <b
              >2. Use of Demographic / Profile Data / Your Information/ other
              Information-</b
            >
          </p>
          <p>
            To the extent we use your personal information; we will provide you
            the ability to opt-out of such uses. We use your personal
            information to resolve disputes; troubleshoot problems; help promote
            a safe service; and inform you about updates; detect and protect us
            against error, fraud and other criminal activity; enforce our terms
            and conditions; and as otherwise described to you at the time of
            collection. We identify and use your IP address to help diagnose
            problems with our server, and to administer our internal processes.
          </p>
          <p><b>3. Sharing of Your information-</b></p>
          <p>
            We may share Your information (as defined in Terms of Use) with our
            other corporate entities and affiliates to help detect and prevent
            identity theft, fraud and other potentially illegal acts; correlate
            related or multiple accounts to prevent abuse of our System
          </p>
          <p>
            We may disclose your information if required to do so by law or in
            the good faith and belief that such disclosure is reasonably
            necessary to respond to subpoenas, court orders, or other legal
            process. We may disclose personal information to law enforcement
            offices, third party rights owners, or others in the good faith and
            belief that such disclosure is reasonably necessary to: enforce our
            Terms or Privacy Policy; respond to claims that posting or other
            content violates the rights of a third party; or protect the rights,
            property or personal safety of our users or the general public.
          </p>
          <p>
            We and our affiliates will share / sell some or all of your Your
            information with another business entity should we (or our assets)
            plan to merge with, or be acquired by that business entity, or
            re-organization, amalgamation, restructuring of business. Should
            such a transaction occur that other business entity (or the new
            combined entity) will be required to follow this privacy policy with
            respect to your personal information.
          </p>
          <p><b>4. Security Precautions-</b></p>
          <p>
            DMS has stringent security measures in place to protect the loss,
            misuse, and alteration of the information under our control.
            Whenever you change or access your account information, we offer the
            use of a secure server. Once your information is in our possession
            we adhere to strict security guidelines, protecting it against
            unauthorized access.
          </p>
          <p><b>5. Your Consent-</b></p>
          <p>
            By using DMS and/ or by providing your information, you consent to
            the collection and use of the information you disclose on the DMS in
            accordance with this Privacy Policy, including but not limited to
            your consent for sharing your information as per this privacy
            policy.
          </p>
          <p>
            If we decide to change our privacy policy, we will post those
            changes on this page so that you are always aware of what
            information we collect, how we use it, and under what circumstances
            we disclose it.
          </p>
          <p><b>6. Grievance Officer</b></p>
          <p>
            In accordance with Information Technology Act 2000 and rules made
            there under, the name and contact details of the Grievance Officer
            are provided below:
          </p>
          <p><b>Phone:</b> +91 1800 3010 3366 ( Help Desk )</p>
          <p><b>Email:</b> dmsnxt.hhp@samsung.com (MX)</p>
          <p>dmsnxt.ce@samsung.com (VD &amp; DA)</p>
          <p><b>Time:</b> 9:30 ~ 23:30 (Help Desk)</p>
        </div>
      </template>
      <template slot="action">
        <ur-button @click="closeModal" main>Okay</ur-button>
      </template>
    </ur-modal>
  </div>
</template>

<script>
export default {
  computed: {
    modal() {
      return this.$refs.modal;
    },
  },
  methods: {
    openModal() {
      this.modal.open();
    },
    closeModal() {
      this.modal.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.ui-footer,
.ui-footer-links {
  display: flex;
  flex-flow: row nowrap;
}
.ui-footer {
  padding-left: 48px;
  border-top: 1px solid #eaeaea;
  max-height: 100px;
}
.ui-footer-links__item {
  margin: 8px 0px;
  padding: 0px 16px;
  font-size: 12px;
  color: #666666;
}
.ui-footer-links__item + .ui-footer-links__item {
  border-left: 1px solid #eaeaea;
}
</style>
